import { IApp, IApp2 } from '@todesktop/shared';

export const isTDBuilderApp = (app: IApp | IApp2): app is IApp2 => {
  return (app.schemaVersion ?? 0) >= 2;
};

export function isElectronApp(app: IApp | IApp2): app is IApp {
  return 'appType' in app && app.appType === 'electron';
}
